// extracted by mini-css-extract-plugin
export default {"Left":"ResetPassword_Left__3BxxQ","BlueBrandButton":"ResetPassword_BlueBrandButton__fc+cy"};